import React from "react";
import { useHospitalSearch } from "../hooks/useHospitalSearch";
import styles from "../styles/ChatbotWindow.module.css";

interface Props {
  lat?: number;
  lng?: number;
  onSelect: (id: string, name: string, distance: number) => void;
}

const HospitalSearch: React.FC<Props> = ({ lat, lng, onSelect }) => {
  const { searchText, hospitals, loading, handleChange } = useHospitalSearch(lat, lng);

  return (
    <div className={styles.hospitalSearch}>
      <input
        className={styles.hospitalInput}
        placeholder="Search hospital..."
        value={searchText}
        onChange={handleChange}
        autoFocus
      />
      {loading && <div className={styles.hospitalLoading}>Searching...</div>}
      <div className={styles.hospitalList}>
        {hospitals.map((h) => (
          <div key={h._id} className={styles.hospitalItem} onClick={() => onSelect(h._id, h.name, h.distance)}>
            <div className={styles.hospitalInfo}>
              <span className={styles.hospitalName}>{h.name}</span>
              <span className={styles.hospitalAddress}>{h.address}</span>
            </div>
            <span className={styles.hospitalDist}>{h.distance?.toFixed(1)} km</span>
          </div>
        ))}
        {!loading && hospitals.length === 0 && (
          <div className={styles.hospitalEmpty}>No hospitals found</div>
        )}
      </div>
    </div>
  );
};

export default HospitalSearch;
